import React from 'react';
import { PageSwitcherTypes } from '../../data';
import { SwitcherLink } from './components';
import type { LinkProps } from './types';

export const ExternalSwitcherLink = ({ children, to, ...props }: LinkProps) => (
  <SwitcherLink as={PageSwitcherTypes.External} to={to} {...props}>
    {children}
  </SwitcherLink>
);

export default ExternalSwitcherLink;
